<template>
  <div id='box'>
     <!-- 头部组件 -->
    <!-- <header class='box'>
      <headers :is_register='true'></headers>
    </header> -->
    <!--  :style="{ 'background-image': 'url(' + bg + ')' }" -->
    <div class="boxs">
      <div class="bboxs">
        <div class="titseto" @click="logasd">
        <!-- 华中版权综合服务平台 -->
        <img
          :src="logo"
          alt=""
          class="bqv2-header-title-logo pointer"
        />
      </div>
      <div class="seaw" style="cursor: pointer;" >
        已有账号？ <span @click="tiajzuha">请登录</span>
        
      </div>
      </div>
    </div>
    <div class="form">
      <div class='content'>
      <header class='title'></header>
        <!-- <div class="step flex">
          <div class='step_item step_item1'>
            <img class='step_img' :src="img1" alt="">
            <div class='step_content flex_center'>
              <img class='icon-img' :src="register7" alt="">
              <span class='step_text'>用户注册</span>
            </div>
          </div>
          <div class='step_item step_item1'>
            <img class='step_img step_img1' :src="img1" alt="">
            <div class='step_content flex_center' style="color: #0068b7">
              <img class='icon-img' :src="register2" alt="">
              <span class='step_text'>审核账号</span>
            </div>
          </div>
          <div class='step_item step_item1'>
            <img class='step_img step_img1' :src="img1" alt="">
            <div class='step_content flex_center' style="color: #0068b7">
              <img class='icon-img' :src="register1" alt="">
              <span class='step_text'>注册成功</span>
            </div>
          </div>
        </div> -->
        <div class="step flex">
          <div class='step_item step_item2'>
            <img class='step_img' :src="img1" alt="">
            <div class='step_content flex_center'>
              <img class='icon-img' :src="register7" alt="">
              <span class='step_text'>用户注册</span>
            </div>
          </div>
          <div class='step_item step_item2'>
            <img class='step_img step_img1' :src="img1" alt="">
            <div class='step_content flex_center' style="color: #0068b7">
              <img class='icon-img' :src="register1" alt="">
              <span class='step_text'>注册成功</span>
            </div>
          </div>
        </div>
        <div class='forms' v-if="school == '1'">

          <el-form ref="form" class='el-forms' :model="form" label-width="120px" size='small' style="padding-top:15px">
          <el-form-item
          label="注册类型"
          class="sex starts"
          prop="publishStatus"
        >
            <el-radio-group
                v-model="form.userType"
                :disabled="disabledasd"
                :rules="[
              { required: true, message: '请选择注册类型',trigger:'blur'},
              ]"
              >
                <el-radio label="1">自然人</el-radio>
                <el-radio class="left" label="2">法人</el-radio>
              </el-radio-group>
              </el-form-item>
            <el-form-item label="代理机构名称"
            >
              <div class='schoolName'>{{schoolName}}</div>
            </el-form-item>
            <!-- <el-form-item label="姓名"
            v-if="form.userType == '1'"
            prop="name" 
            :rules="[
              { required: true, message: '姓名不能为空',trigger:'blur'},
              ]"
            >
              <el-input v-model="form.name" placeholder="请输入真实姓名"></el-input>
            </el-form-item> -->
            <el-form-item label="姓名"
            v-if="form.userType == '1'"
            prop="name" 
            :rules="[
              { required: true, message: '姓名不能为空',trigger:'blur'},
              ]"
            >
              <el-input v-model="form.name" placeholder="请输入真实姓名"></el-input>
            </el-form-item>
            <el-form-item label="单位名称"
             v-if="form.userType == '2'"
            prop="name" 
            :rules="[
              { required: true, message: '单位名称不能为空',trigger:'blur'},
              ]"
            >
              <el-input v-model="form.name" placeholder="请输入单位名称"></el-input>
            </el-form-item>
            <!-- <el-form-item label="单位名称"
             v-if="form.userType == '2'"
            prop="name" 
            :rules="[
              { required: true, message: '姓名不能为空',trigger:'blur'},
              ]"
            >
              <el-input v-model="form.name" placeholder="请输入真实姓名"></el-input>
            </el-form-item> -->

            <el-form-item label="内设机构名称"
            >
              <el-select v-model="form.school" placeholder="请选内设机构" class='select'>
                <el-option v-for="(i,index) in cosyu" :label="i.academy_name" :key="index" :value="i.academy_id"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="类别"
            >
              <el-select v-model="form.userType" placeholder="请选择类别" class='select'>
                 <el-option label="自然人" value="1"></el-option>
                  <el-option label="法人(企业法人、机关法人、事业单位法人、社会团体法人)" value="2"></el-option>
              </el-select>
            </el-form-item> -->
             <el-form-item label="密码"
             :rules="[{
                required: true,
                message: '请输入密码(字母、数字、最少两种组合6-20位)',
                trigger: 'blur'
                }, {
                    min: 6,
                    max: 20,
                    message: '长度在 6 到 20 个字符'
                }, {
                    pattern: /^(\w){6,20}$/,
                    message: '只能输入6-20个字母、数字、下划线'
                }]"
              prop="password"
             >
              <el-input type="password" @blur="blurpwd()" v-model="form.password" placeholder="请设置密码"></el-input>
            </el-form-item>
            <el-form-item label="确认密码"
            :rules="[
              { required: true, message: '请再次输入密码',trigger:'blur'},
              ]"
              prop="repassword"
              >
              <el-input type="password" v-model="form.repassword" placeholder="请再次输入密码"></el-input>
            </el-form-item>
            <el-form-item label="手机号"
              prop="phone"
             :rules="[
              { required: true, message: '手机号不能为空',trigger:'blur'},
              { pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '请输入正确的手机号' }
              ]"
             >
              <el-input @blur="blur1" v-model="form.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="图形验证码"
            :rules="[
              { required: true, message: '请输入图形验证码',trigger:'blur'},
              ]"
              prop="Graphicverificationcode"
            >
              <el-input v-model="form.Graphicverificationcode" placeholder="请输入图形验证码">
                <!-- <template slot="append"> <div class='verificationcode' @click="checkCodeofRandom">{{Graphicverificationcode}}</div></template> -->
                 <template slot="append"> <img-verify style="right: -1px;" @imgCode="imgCode"/></template> 
              </el-input>
            </el-form-item>
             <!-- <el-form-item label="验证码"
              :rules="[
                { required: true, message: '验证码不能为空',trigger:'blur'},
              ]"
              prop="verificationcode"
             >
              <el-input v-model="form.verificationcode" placeholder="请输入验证码">
                <template slot="append"><el-button type="primary" class='getCode' @click='getCode'>{{ content }}</el-button></template> 
              </el-input>
            </el-form-item> -->
            
            <!-- <el-form-item> -->
              <div class='bottoms'>
                  <el-button type="primary" @click="onSubmit('form')">立即注册</el-button>
              </div>
            <!-- </el-form-item> -->
             <!-- <el-form-item>
               <el-radio v-model="radio" label="1">我已阅读并同意 <span class='blue'>《湖北政务网注册协议》</span></el-radio>
             </el-form-item> -->
          </el-form>
        </div>
        <div class='forms' v-if="school == '2'">
          <el-form ref="form1" class='el-forms' :model="form" label-width="120px" size='small'> 
            <el-form-item
          label="注册类型"
          class="sex starts"
          prop="publishStatus"
        >
            <el-radio-group
                v-model="form.userType"
                :disabled="disabledasd"
                :rules="[
              { required: true, message: '请选择注册类型',trigger:'blur'},
              ]"
              >
                <el-radio label="1">自然人</el-radio>
                <el-radio class="left" label="2">法人</el-radio>
              </el-radio-group>
              </el-form-item>
            <!-- <el-form-item label="姓名" prop="name"
            :rules="[
              { required: true, message: '姓名不能为空',trigger:'blur'},
              ]">
              <el-input v-model="form.name" placeholder="请输入真实姓名"></el-input>
            </el-form-item> -->
            <el-form-item label="姓名"
            v-if="form.userType == '1'"
            prop="name" 
            :rules="[
              { required: true, message: '姓名不能为空',trigger:'blur'},
              ]"
            >
              <el-input v-model="form.name" placeholder="请输入真实姓名"></el-input>
            </el-form-item>
            <el-form-item label="单位名称"
             v-if="form.userType == '2'"
            prop="name" 
            :rules="[
              { required: true, message: '单位名称不能为空',trigger:'blur'},
              ]"
            >
              <el-input v-model="form.name" placeholder="请输入单位名称"></el-input>
            </el-form-item>
             <el-form-item label="密码" prop="password" 
             :rules="[{
                required: true,
                message: '请输入密码(字母、数字、最少两种组合6-20位)',
                trigger: 'blur'
                }, {
                    min: 6,
                    max: 20,
                    message: '长度在 6 到 20 个字符'
                }, {
                    pattern: /^(\w){6,20}$/,
                    message: '只能输入6-20个字母、数字、下划线'
                }]"
             >
              <el-input type="password" v-model="form.password" @blur="blurpwd()" placeholder="请设置密码(字母与数字组合)"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="repassword" 
            :rules="[
              { required: true, message: '请再次输入密码',trigger:'blur'},
              ]">
              <el-input type="password" v-model="form.repassword" placeholder="请再次输入密码"></el-input>
            </el-form-item>

            
            <!-- <el-form-item label="类别"
            >
              <el-select v-model="form.userType" placeholder="请选择类别" class='select'>
                 <el-option label="自然人" value="1"></el-option>
                  <el-option label="法人(企业法人、机关法人、事业单位法人、社会团体法人)" value="2"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="手机号" prop="phone"
            :rules="[
              { required: true, message: '手机号不能为空',trigger:'blur'},
              { pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '请输入正确的手机号' }
              ]"
            >
              <el-input @blur="blur1()" v-model="form.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="图形验证码" prop="Graphicverificationcode"
            :rules="[
              { required: true, message: '请输入图形验证码',trigger:'blur'},
              ]">
              <el-input v-model="form.Graphicverificationcode" placeholder="请输入图形验证码">
                <!-- <template slot="append"> <div class='verificationcode' @click="checkCodeofRandom">{{Graphicverificationcode}}</div></template>   -->
                <template slot="append"> <img-verify style="right: -1px;" @imgCode="imgCode"/></template> 
              </el-input>
            </el-form-item>
             <!-- <el-form-item label="验证码" prop="verificationcode"
              :rules="[
                { required: true, message: '验证码不能为空',trigger:'blur'},
              ]" >
              <el-input v-model="form.verificationcode" placeholder="请输入验证码">
                <template slot="append"><el-button type="primary" class='getCode' @click='getCode'>{{content}}</el-button></template> 
              </el-input>
            </el-form-item> -->
            
              <div class='bottoms' >
                  <el-button type="primary"  @click="onSubmit('form1')">立即注册</el-button>
              </div>
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="handleClose"
      v-loading='loading'
      >
      <!-- <span>这是一段信息</span> -->
      <div class='center'>注册协议</div>
      <div class='agreement_content'>
        <!-- <div class='time'>版本生效日期：2021年3月26日</div> -->
        <div class='agreement' v-html="this.agreement"></div>
      </div>  
      <span slot="footer" class="flex_nav">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="dialogVisible = false">同意并继续</el-button>
      </span>
    </el-dialog>
    <!-- 尾部组件 -->
    <div class='box box1'>
      <tails></tails>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui';
import headers from "@/components/header";
import tails from "@/components/tail";
import stepa from "@/assets/step_a.png";
import stepb from "@/assets/step_b.png";
import register1 from "@/assets/register1.png";
import register2 from "@/assets/register2.png";
import register3 from "@/assets/register3.png";
import register4 from "@/assets/register4.png";
import register5 from "@/assets/register5.png";
import register6 from "@/assets/register6.png";
import register7 from "@/assets/register7.png";
import register8 from "@/assets/register8.png";
import imgVerify from "@/components/imgVerify";
import logo from "@/assets/V2/logo-V2.png";
export default {
  data() {
    return {
      dialogVisible:true,
      img1:stepa,
      img2:stepb,
      register1,
      register2,
      register3,
      register4,
      register5,
      register6,
      register7,
      register8,
      school:'2',
      schoolName:'',
       logo:logo,
      form:{
        name:'',
        phone:'',
        verificationcode:'',
        password:'',
        repassword:'',
        Graphicverificationcode:'',
        school:'',
        userType:'1',
      },
      Graphicverificationcode:'1234',
      code:'',
      reg_tel :/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
      colleges:'',
      cosyu:'',
      academyId:'',
      disabledasd:false,
      // rules:{
      //    name: [{ required: true, message: '姓名不能为空', trigger: 'blur' },],
      //    phone:[{ required: true, message: '手机号不能为空',trigger:'blur'},
      //          {pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '请输入正确的手机号' }],
      //   verificationcode:[{ required: true, message: '验证码不能为空',trigger:'blur'}, ],
      //   password:[{ required: true, message: '请输入密码', trigger: 'blur' }, 
      //                 { min: 6, max: 20, message: '长度在 6 到 20 个字符' }, 
      //                 { pattern: /^(\w){6,20}$/, message: '只能输入6-20个字母、数字、下划线' }],
      //   repassword:[ { required: true, message: '请再次输入密码',trigger:'blur'},],
      //   Graphicverificationcode:[  { required: true, message: '请输入图形验证码',trigger:'blur'},],
      // },
      // agreementas:'',
      agreement:'',
      loading:true,
      totalTime: 60,
      content: "获取验证码",
      canClick: true,
      only:false,
      gaoxiaoid:'',
      bg:''
    }
  },
  components:{
    headers,
    tails,
    imgVerify
  },
  beforeCreate() {
		
	},
  created(){
this.bg = this.$baseUrl + window.localStorage.getItem("V2-bg").split("|")[0];
  },
  mounted(){
    console.log(sessionStorage.getItem("collegeCode"),"sdas")
    this.colleges = this.$route.query.code
    // alert(this.colleges)
    if(this.colleges == '' || this.colleges == undefined){
         this.school = '2'
    }else{
        this.school = '1'
        this.Universityname();
    }
    if(sessionStorage.getItem('collegeCode')){
      this.colleges = sessionStorage.getItem('collegeCode')
      this.school = '1' 
      this.Universityname();
    }
    // this.agreement();
    // this.checkCodeofRandom()
    this.getagreement()
  },
  methods: {
    tiajzuha(){
      this.$router.push('/login')
    },
    logasd(){
      window.localStorage.setItem("cur",0);
      this.$router.push('/')
    },
        imgCode(code){
      this.Graphicverificationcode = code;
      // console.log(code,"[[[][]")
    },
    // agreement(){
    //   this.$getHttp('/pc/userLogin/getProtocal',{ //获取协议
    //             des:'reg',//mima
    //         }).then((res)=>{
    //           this.agreementas = res.r[0].content;
    //           // console.log(res.r[0].content,"11111111111")
    //         })
    // },
    blurpwd(){
      this.$getHttp('/pc/userLogin/textValidator',{ //密码格式
          password:this.form.password,//mima
      }).then((res)=>{
        // console.log(res,"密码格式")
      })
    },
    blur1(){ //监听手机号输入判断是否存在
            // console.log(this.form.phone,'移出')
            this.$getHttp('/pc/userLogin/verifyUser',{ //手机号唯一性
                phone:this.form.phone,//高校id
            }).then((res)=>{
              // console.log(res,"手机号唯一性")
              this.only = true
            }).catch(error=>{
              this.only = false
            })
    },
    Universityname(){
      this.$getHttp('/pc/userLogin/findCollege',{ //获取高校名字
            collegeCode:this.colleges,//高校id
        }).then(res=>{
          // console.log(res.msg)
          if(res.msg == '代理机构不存在'){
            this.$alert('代理机构不存在，请检查网址连接。', '代理机构不存在', {
              confirmButtonText: '确定',
              callback: action => {
                this.$message({
                  type: 'info',
                  message: `action: ${ action }`
                });
              }
            });
            this.school = '2';
            this.colleges = '';
          }else{
            this.gaoxiaoid =  res.r[0].college_id
            this.schoolName =  res.r[0].college_name;
            this.$getHttp('/pc/userLogin/findAcademy',{ //获取院校名字
                collegeId:res.r[0].college_id,//高校id
            }).then(res=>{
              this.cosyu = res.r;
              // console.log( this.cosyu,'//高校id')
            })
          }
          
        })
      
    },
    // checkCodeofRandom() {
    //   var nums = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9");
    //   // 初始化 拼接字符串
    //   var str = "";
    //   for (let i = 0; i < 4; i++) {
    //     var p = Math.floor(Math.random() * 1000) % 10;
    //     //拼接验证码  随机抽取大小写字母和数字
    //     str += nums[p];
    //   }
    //   this.Graphicverificationcode = str;
    // },
    handleClose(done) {
      this.$confirm('确认取消注册吗？')
        .then(_ => {
          this.$router.push('/login')
        })
        .catch(_ => {});
    },
    onSubmit(formName) {
      // console.log(formName,"17638148975");
      // if(!this.radio){
      //   this.$message.error('必须同意注册协议')
      // }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
      if(!this.form.userType){
        Message.error('请选择类别');
        return false;
      }
      if(this.Graphicverificationcode != ''){

      }else{
        Message.error('请获取短信验证码');
         return false;
      }
      // if(this.form.verificationcode != ''){  //判断验证码是否为空

      // }else{
      //   Message.error('请输入短信验证码');
      //    return false;
      // }
        // if(this.form.verificationcode == this.code){ ///判断验证码是否与短信验证码一致

        // }else{  
        //   Message.error('短信验证码不一致，请确认后输入');
        //    return false;
        // }
        if(this.form.password == this.form.repassword){ /////判断密码是否一致
          
        }else{
          Message.error('密码不一致，请确认后输入');
             return false;
        }
        if(this.form.Graphicverificationcode == this.Graphicverificationcode){ //判断图形验证码是否一致

        }else{
          Message.error('图形验证码错误，请确认后输入');
           return false;
        }
          if(this.colleges == '' || this.colleges == undefined){
            this.$postHttp('/pc/userLogin/addUser',{
              userName:this.form.name,//用户名
              password:this.form.password,//密码
              phone:this.form.phone,//手机号
              role:'1',//角色
              checkStatus:1,
              userType:this.form.userType,
              // collegeId string 否 高校
              // academyId 院校
              //checkStatus:'', //审核状态（社会人员不传 工作人员传0）
              code:this.form.verificationcode, //验证码
            }).then((res)=>{
            this.$message({message: '注册成功！！！',type: 'success'});
            //  console.log(res,"注册成功！！！222")
            //  console.log(res.r.userId,"注册成功userId222")
            //  console.log(res.msg,"注册成功！！！222")
            window.sessionStorage.setItem('userInfo',JSON.stringify(res.r))
            window.sessionStorage.setItem('dengji','1')
            window.sessionStorage.setItem('checkStatus','8')
            //  console.log(sessionStorage.getItem('checkStatus'),"！！！！！！！！！！")
            this.$router.push('/examine')
        })
        }else{
          // console.log(this.form.school,"form.schoolform.schoolform.school")
          // console.log(this.colleges,"gaixa")
        //  if(this.form.school == '' || this.form.school == undefined){
          //  Message.error('请选择院校！');
        //  }else{
            this.$postHttp('/pc/userLogin/addUser',{
            userName:this.form.name,//用户名
            password:this.form.password,//密码
            phone:this.form.phone,//手机号
            role:'1',//角色
            userType:this.form.userType,
            collegeId:this.gaoxiaoid ,// string 否 高校
            academyId:this.form.school ,// 院校
            checkStatus:'0', //审核状态（社会人员不传 工作人员传0）
            code:this.form.verificationcode, //验证码
        }).then((res)=>{
          this.$message({message: '注册成功！！！',type: 'success'});
           window.sessionStorage.setItem('dengji','2')
          // console.log(res,"注册成功！！！111")
          // console.log(res.r.userId,"注册成id功！！！111")
          window.sessionStorage.setItem('userInfo',JSON.stringify(res.r))
          window.sessionStorage.setItem('checkStatus',JSON.stringify(res.r.checkStatus))
             this.$router.push('/examine')
        })
        //  }
        }
     
    },
    getCode(){
      if(!this.reg_tel.test(this.form.phone)){
        this.$message.error('请填写正确的手机号')
        return
      }
      if(!this.only){
        this.$message.error('手机号已存在')
        return
      }
      if(this.form.Graphicverificationcode != this.Graphicverificationcode){ //判断图形验证码是否一致
        Message.error('图形验证码错误，请确认后输入');
          return false;
      }
      if (!this.canClick) return; //改动的是这两行代码
      this.canClick = false;
      this.content = this.totalTime + "s后重新发送";
      let clock = window.setInterval(() => {
        this.totalTime--;
        this.content = this.totalTime + "s后重新发送";
        if (this.totalTime < 0) {
          window.clearInterval(clock);
          this.content = "重新发送验证码";
          this.totalTime = 60;
          this.canClick = true; //这里重新开启
        }
      }, 1000);
      this.$getHttp('/pc/userLogin/phoneVerification',{
        phone:this.form.phone,
      }).then(res=>{
        this.code = res.code;
        // console.log(this.code)
        // console.log(res)
      }).catch(error=>{
        // console.log(error)
      })
    },
    getagreement(){
      this.$getHttp("/pc/userLogin/getProtocal", {des:'reg'})
      .then((res) => {
        if (res.success) {
          this.agreement = res.r[0].content
        }else{
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
        this.loading = false
      })
      .catch((error) => {
        // console.log(error);
        this.loading = false
      });
    }
  }
}
</script>

<style lang='less' scoped>
.bqv2-header-title-logo {
      vertical-align: middle;
      margin-left:0px;
      width: 427px;
      height: auto;
    }
.titseto{
    font-size: 25px;
    font-weight: normal;
    font-stretch: normal;
    // color:  #0068b7;
    cursor: pointer;
    align-items: center;
    padding-left: 16px;
     line-height: 90px;
    float: left;
}
.boxs{
  width: 100%;
  height: 90px;
  overflow: hidden;
  background-repeat:no-repeat;
  background-attachment:fixed;
  background-size: contain;
  // background-color: rgba(255, 255, 255, 0.18);
    // background-color: rgba(69, 63, 63, 0.88);
    background-color: #ffffff;
  filter: blur(0.3px);

}
.bboxs{ 
   height: 90px;
   width: 1200px;
   margin: 0 auto;
  //  background: white;
   .seaw{
     float: right;
     color: #333;
     line-height: 90px;

     span{
      //  color: #2264D2;
     }
   }
}
  #box{
    // position: absolute;
    // left: 0;
    // top: 0;
    // // width: 100%;
    // height: 100%;
    background: #f3f6f8;
     
  }
  .content{
    background: #D2E0F6;
  }
  .form{
    height: calc( 100% - 243px );
    min-height: 690px;
    background: #D2E0F6;
    .schoolName{
      color: #606266;
    }
    .title{
      padding-top: 10px;
      padding-bottom: 30px; 
      height: 0px;
       
      font-size: 26px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 0px;
      letter-spacing: 0px;
      color: #333333;
    }
    .step_item{
      position: relative;
      height: 65px;
      .step_img{
        width: 100%;
        height: 100%;
      }
      .step_img1{
        opacity: 0.2;
      }
      .step_content{
        text-align: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        font-size: 20px;
        img{
          width: 36px;
          height: 36px;
        }
        .iconfont{
          font-size: 26px;
        }
        .icon-HTyonghushenhe{
          font-size: 30px;
        }
      }
    }
  
    .step_item2{
      width: 600px;
    }
    .forms{
      margin-top: 30px;
      height: 536px;
      background: #fff;
      border-radius: 10px;
      .el-forms{
        width: 700px;
        margin: 0 auto;
        padding-top: 50px;
      }
    }
  }
  .box{
    background: #fff;
  }
  .box1{
    background: #f2f2f2;
  }
  .center{
    text-align: center;
    margin-bottom: 24px;
    height: 35px;
     
    font-size: 26px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 35px;
    letter-spacing: 0px;
    color: #333333;
  }
  .flex_nav{
    width: 600px;
    margin: 0 auto;
  }
  .agreement_content{
    width: 950px;
    margin: 0 auto;
    .time{
      height: 32px;
       
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 32px;
      letter-spacing: 0px;
      color: #333333;
      margin-bottom: 32px;
    }
    .agreement{
       
      font-weight: normal;
      font-stretch: normal;
      line-height: 32px;
      letter-spacing: 0px;
      color: #333333;
      height: 300px;
      overflow: auto;
    }
    .agreement::-webkit-scrollbar {    /*滚动条整体样式*/
      width: 10px;                        /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }
    .agreement::-webkit-scrollbar-thumb {  /*滚动条里面小方块*/
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
      background: #ebebeb;
    }
    .agreement::-webkit-scrollbar-track {  /*滚动条里面轨道*/
      /* -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2); */
      border-radius: 10px;
      background: #fff;
    }
  }
  .select{
    width: 100%;
  }
  .bottoms{
    text-align: center;
    .el-button{
    width: 370px;
    height: 36px;
    background-color:  #0068b7;
    border-radius: 10px;
    }
  }
  .blue{
    color:  #0068b7;
  }
  .verificationcode{
    width: 80px;
    height: 26px;
    background-color: #D3E0F6;
    border-radius: 8px;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 26px;
    letter-spacing: 2px;
    color:  #0068b7;
    text-align: center;
    cursor: pointer;
  }
  // .getCode{
  //   background: #fff !important;
  // }
  canvas{
    right: -1px;
  }

  @media screen and (max-width:1024px) {
    *{
      font-size: 12px;
    }
    .boxs{
      height: 3.65rem;
    line-height: 3.65rem;
    }
    .bboxs{
      height: 3.65rem;
    line-height: 3.65rem;
      .titseto{
        font-size: 0.9rem;
      }
    }
    .bboxs{
      width: 100%;
    }
    .titseto{
      line-height: 3.65rem;
    }
    .bboxs .seaw{
      line-height: 3.65rem;
     
    }
    .seaw{
      font-size: 0.8rem;
      margin-right: 1rem;
      
      span{
         font-size: 0.8rem;
      }
    }
    .step{
      padding: 0rem 1rem;
    }
    .form .step_item2{
      height: 3rem;
      width: 16rem;
    }
    
    .form .step_item .step_content img{
      width: 1.2rem;
      height: 1.2rem;
    }
    .form .forms{
          width: 96vw;
    margin: 2vw;
    height: 100%;
    padding-bottom: 2rem;
    }
    
    .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
      margin-right: 2rem;
      margin-bottom: 28px;
    }
    .content{
      width: 100%;
    }
    input{
      font-size: 0.8rem;
    }
    .form .forms .el-forms{
      width: 100%;
    }
    .bottoms .el-button{
          width: 75%;
    }
    .el-input{

    }
    .agreement_content{
      width: 100%;
    }
    .flex_nav{
      width: 100%;
    }
    .el-form-item__content{
      margin: 0 auto;
    }
input{
    /* placeholder颜色 */
    color: #aab2bd;
    /* placeholder字体大小 */
    font-size: 122px;
}
.content{
  padding-bottom: 2rem;
}
  }

// @media screen and (max-width: 1024px) {
//   .el-select-dropdown.el-popper{
//     left: auto !important;
//   }
// }
</style>


// WEBPACK FOOTER //
// src/view/register.vue